import { FormBuilder } from "@/components/form-builder"
import { FormActions } from "../components/person-steps/form-actions"
import { usePersonAttachments } from "../hooks/use-person-attachments"

interface PersonAttachmentsViewProps {
  personId: number
  onContinue: () => void
  onBack: () => void
}

export function PersonAttachmentsView({
  personId,
  onContinue,
  onBack,
}: PersonAttachmentsViewProps) {
  const {
    form,
    isPending,
    onFormSubmit,
    attachmentFields
  } = usePersonAttachments({ personId, onSuccess: onContinue })

  return (
    <div className="space-y-8">
      <div className="bg-darkblue rounded-lg p-8">
        <FormBuilder
          fields={attachmentFields}
          layout={{ columns: 2, gap: "md" }}
          formInstance={form}
          onSubmit={async () => undefined}
          showSave={false}
        />
      </div>

      <FormActions
        isPending={isPending}
        onBack={onBack}
        onSubmit={() => form.handleSubmit(onFormSubmit)()}
      />
    </div>
  )
}
